module.exports = __webpack_public_path__ + "img/lianchuang_bg2.32750041.png";